import { render, staticRenderFns } from "./FooterBarWhite.vue?vue&type=template&id=28e2533e"
import script from "./FooterBarWhite.vue?vue&type=script&lang=js"
export * from "./FooterBarWhite.vue?vue&type=script&lang=js"
import style0 from "./FooterBarWhite.vue?vue&type=style&index=0&id=28e2533e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports